module.exports = __webpack_public_path__ + "static/media/embrace-changes.25159333.jpg";